import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/lemon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M484.1 27.9c28.1 28.1 35.9 68 19 97.1-23.1 39.6 50.1 163.4-82.3 295.9-132.3 132.3-256.4 59.4-295.9 82.3-29 16.9-68.9 9.1-97.1-19-28.1-28.1-35.9-68-19-97.1 23.1-39.6-50.1-163.4 82.3-295.9 132.3-132.3 256.4-59.3 295.9-82.3 29-16.9 68.9-9.1 97.1 19zM461.7 100.8c13.5-23.2-27.8-63.7-50.5-50.5-66.6 38.8-165.6-45.6-286.1 74.8-120.4 120.4-36 219.5-74.8 286.1-13.5 23.2 27.8 63.7 50.5 50.5 66.6-38.8 165.6 45.6 286.1-74.8 120.4-120.4 36-219.5 74.8-286.1zM291.8 109.5c1.4 11-6.4 21-17.4 22.3-54.8 6.9-135.8 87.8-142.6 142.6-1.4 11-11.4 18.7-22.3 17.4-11-1.4-18.7-11.4-17.4-22.3 9.2-73.3 104.2-168.2 177.4-177.4 11-1.4 21 6.4 22.3 17.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/lemon.js
// module id = 1791
// module chunks = 0